import { selectAuth } from '@brands/store/selectors/auth';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '../../../../hooks/useReduxHook';

const SelectAppointmentTypeValidation: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);

  return <Navigate to={userInfo?.role?.name ? `/${userInfo.role.name}/dashboard` : '/dashboard'} replace />;
};

export default SelectAppointmentTypeValidation;
